import { render, staticRenderFns } from "./SkupStavkaEdit.vue?vue&type=template&id=47e5d8e1&scoped=true&"
import script from "./SkupStavkaEdit.vue?vue&type=script&lang=js&"
export * from "./SkupStavkaEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e5d8e1",
  null
  
)

export default component.exports